export const galleryData = {
  bannerSlides: [
    { image: "/images/banner2.jpg", alt: "" },
    { image: "/images/banner3.jpg", alt: "" },
    { image: "/images/banner4.jpg", alt: "" },
    { image: "/images/banner5.jpg", alt: "" },
  ],
  breadcrumb: [
    { label: "HOME", href: "/" },
    { label: "PHOTO GALLERY", href: "/gallery" },
  ],
  title: "PHOTO",
  titleHighlight: "GALLERY",
  images: [
    {
      thumb: "/images/gallery/gal-pg-img12.jpg",
      full: "/images/gallery/gal-pg-big-img12.jpg",
    },
    {
      thumb: "/images/gallery/gal-pg-img13.jpg",
      full: "/images/gallery/gal-pg-big-img13.jpg",
    },
    {
      thumb: "/images/gallery/gal-pg-img14.jpg",
      full: "/images/gallery/gal-pg-big-img14.jpg",
    },
    {
      thumb: "/images/gallery/gal-pg-img15.jpg",
      full: "/images/gallery/gal-pg-big-img15.jpg",
    },
    {
      thumb: "/images/gallery/gal-pg-img16.jpg",
      full: "/images/gallery/gal-pg-big-img16.jpg",
    },
    {
      thumb: "/images/gallery/gal-pg-img2.jpg",
      full: "/images/gallery/gal-pg-big-img2.jpg",
    },
    {
      thumb: "/images/gallery/gal-pg-img4.jpg",
      full: "/images/gallery/gal-pg-big-img4.jpg",
    },
    {
      thumb: "/images/gallery/gal-pg-img5.jpg",
      full: "/images/gallery/gal-pg-big-img5.jpg",
    },
    {
      thumb: "/images/gallery/gal-pg-img6.jpg",
      full: "/images/gallery/gal-pg-big-img6.jpg",
    },
    {
      thumb: "/images/gallery/gal-pg-img7.jpg",
      full: "/images/gallery/gal-pg-big-img7.jpg",
    },
    {
      thumb: "/images/gallery/gal-pg-img10.jpg",
      full: "/images/gallery/gal-pg-big-img10.jpg",
    },
    {
      thumb: "/images/gallery/gal-pg-img11.jpg",
      full: "/images/gallery/gal-pg-big-img11.jpg",
    },
    {
      thumb: "/images/gallery/MIPL 5.jpg",
      full: "/images/gallery/MIPL 5.jpg",
    },
    {
      thumb: "/images/gallery/MIPL 6.jpg",
      full: "/images/gallery/MIPL 6.jpg",
    },
    {
      thumb: "/images/gallery/MIPL 7.jpg",
      full: "/images/gallery/MIPL 7.jpg",
    },
    {
      thumb: "/images/gallery/MIPL 8.jpg",
      full: "/images/gallery/MIPL 8.jpg",
    },
    {
      thumb: "/images/gallery/MIPL 9.jpg",
      full: "/images/gallery/MIPL 9.jpg",
    },
    {
      thumb: "/images/gallery/MIPL 11.jpg",
      full: "/images/gallery/MIPL 11.jpg",
    },
    {
      thumb: "/images/gallery/MIPL 12.jpg",
      full: "/images/gallery/MIPL 12.jpg",
    },
    {
      thumb: "/images/gallery/MIPL 13.jpg",
      full: "/images/gallery/MIPL 13.jpg",
    },
  ],
};